
import React from 'react'
import { useParams } from 'react-router-dom'
import CarDetailContainer from './CarDetailContainer'

const CarDetailContainerWrapper = (props) => {
    const params = useParams()
    return <CarDetailContainer {...props} params={params} />
}

export default CarDetailContainerWrapper
